import { render, staticRenderFns } from "./addChampionSay.vue?vue&type=template&id=7a59e89b&"
import script from "./addChampionSay.vue?vue&type=script&lang=js&"
export * from "./addChampionSay.vue?vue&type=script&lang=js&"
import style0 from "./addChampionSay.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports